import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { registerSW } from "virtual:pwa-register";

// Silent auto-update: combined with `registerType: 'autoUpdate'`,
// `skipWaiting`, and `clientsClaim` in vite.config.ts, a new service worker
// takes over on the next page load without prompting the user.
registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
